import requester from '../utils/requester';
import Platform from '../platform';
import config from '../config';
import moment from 'moment';
import { merge } from 'lodash';
import { store } from 'index';
import { INIT_UI_LANGUAGE } from 'constants/languages';

import {
  getContractNumberSelector,
  getProfileId,
  getUserEmailFromProfile,
  getIsLoggedInSelector,
} from 'reducers/profile/selectors';

const kibanaHost = 'https://es-app-ux-test.volia.com/ux_stat/_doc/?pretty';
const authHeader = 'ZWxhc3RpYzp7dDc/Y0BSSipcJVczI1o1TCtKPDluLiJmLWw/cj4=';

/*
const headerLogin = 'elastic';
const headerPass = '{t7?c@RJ*\\%W3#Z5L+J<9n."f-l?r>';
*/

const postStatInfoEvent = () => {
  const storeState = store.getState();

  const scripts = document.getElementsByTagName('script');

  const scriptsInfo = {
    jsScriptsTotal: scripts.length,
    jsScriptsUrls: [],
  };

  for (let i = 0; i < scripts.length; i++) {
    scriptsInfo.jsScriptsUrls.push(scripts[i].src);
  }

  const dataJSON = {
    app_version: config.appVersion,
    url: window.location.href,
    rnd: Math.random(),
    locale: INIT_UI_LANGUAGE,
    mess_time: moment(),
    device: {
      type: Platform.getDeviceType(),
      vendor: Platform.getBrand(),
      platform: Platform.getName(),
      os_version: Platform.getPlatformVersion(),
      firmware: Platform.getFirmwareVersion(),
      model: Platform.getModelName(),
      did: Platform.getUID(),
      year: Platform.getModelYear(),
      diagonal: Platform.getModelDiagonal(),
      support_uhd: Platform.supportsUHD(),
      support_uhd_8k: Platform.supportsUHD8K(),
      support_hdr: Platform.supportsHDR(),
    },
    user: {
      auth: getIsLoggedInSelector(storeState),
      contract: getContractNumberSelector(storeState) || '',
      uid: getProfileId(storeState) || 0,
      email: getUserEmailFromProfile(storeState) || '',
      subscriptions: [],
    },
  };

  merge(dataJSON, scriptsInfo);

  _postRequest(dataJSON);
};

function _postRequest(dataJSON) {
  const dataToPOST = dataJSON;

  try {
    requester({
      method: 'post',
      url: kibanaHost,
      appendParams: false,
      extendHeadersWithSession: false,
      headers: {
        Authorization: `Basic ${authHeader}`,
      },
      data: dataToPOST,
    });
  } catch (error) {
    console.error(error);
  }
}

export default {
  postStatInfoEvent,
};
